import axios from './axios'
export default class PartnerService{
    static async govtList(){
        return await axios.get("/partner/list");
    }

    static async industryList(){
        return await axios.get("/industry-partner/list");
    }

    static async awardList(){
        return await axios.get("/awards/list");
    }
}